'use client';

import Script from 'next/script';
import { useEffect, useState } from 'react';
import { environment } from '@/config/environment';
import { isKnownAutomationClient } from '@/lib/user-agent';

export default function MetaPixel() {
  const pixelId = environment.analytics.metaPixelId;

  // Decided after mount: the automation check needs the real screen size.
  const [allowed, setAllowed] = useState(false);
  useEffect(() => setAllowed(!isKnownAutomationClient()), []);

  // Don't load Meta Pixel if disabled in environment, missing ID, or a known bot
  if (!environment.analytics.enabled || !pixelId || !allowed) {
    return null;
  }

  return (
    <>
      {/* Preconnect for faster loading */}
      <link rel="preconnect" href="https://connect.facebook.net" />

      {/* Meta Pixel base code */}
      <Script
        id="meta-pixel"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${pixelId}');
            fbq('track', 'PageView');
          `,
        }}
      />

      {/* noscript fallback for users with JavaScript disabled */}
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`}
          alt=""
        />
      </noscript>
    </>
  );
}
